import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'


import router from './router'
import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';
import moment from 'moment';
import 'moment/locale/es';


import { abilitiesPlugin } from '@casl/vue';
import ability from './casl/ability';
import brand from './config/brand';


import 'vuetify/dist/vuetify.min.css';

//import es from 'vuetify/es5/locale/es';

moment.locale('es');

Vue.use(vuetify);

// Configuración de Vue Toastification
const toastOptions = {
  position: 'bottom-right',
  timeout: 3000,
  closeOnClick: true,
};

Vue.use(Toast, toastOptions);

Vue.use(abilitiesPlugin, ability, {
  useGlobalProperties: true
});


Vue.config.productionTip = false

Vue.prototype.$moment = moment;
Vue.prototype.$brand = brand;
window.moment = moment;

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
